import { AlpineComponent } from "alpinejs";
import {
    default as AjaxList,
    ListXDataContext as AjaxListXDataContext,
    ListOptions as AjaxListOptions
} from '../../components/AjaxList/Classes/List';
import ListItem from "../../components/AjaxList/Classes/Item";
import { IHistoryStateProps } from "../../utils/historyState";

export type ListComponent = AlpineComponent<AjaxListXDataContext<ListItem> & {
    activeFilters: { uid: string, label: string }[];
    filterOpen: boolean;
    heroOpened: boolean;
    listFilters: () => void;
    toggleFilter: () => void;
}>;

export type ListOptions = AjaxListOptions & IHistoryStateProps;

const List = (options: ListOptions, filterData = {}):ListComponent => {
    return {
        ...AjaxList(options, filterData),
        activeFilters: [],
        filterOpen: false,
        heroOpened: true,

        created() {
            this.listFilters();

            // Hero search state
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this.heroOpened = !urlParams.has('federal_states');
        },

        listFilters() {
            function removeDuplicates(arr: any[]) {
                return arr.filter((item, index) => arr.indexOf(item) === index);
            }

            // Merge filter ids
            let filterIds: any[] = [];
            if (this.filter) {
                if (this.filter.data.states) {
                    filterIds = filterIds.concat(this.filter.data.states);
                }
                if (this.filter.data.federal_states) {
                    filterIds = filterIds.concat(this.filter.data.federal_states);
                }
                filterIds = removeDuplicates(filterIds);
            }

            // Set activeFilters
            filterIds.forEach(uid => {
                const filterItem = this.$el.querySelector(`.filter-input[value="${uid}"]`) as HTMLElement;
                if (filterItem) {
                    const label = filterItem.dataset.title || "";
                    this.activeFilters.push({ uid, label });
                }
            });
        },

        toggleFilter() {
            this.filterOpen = !this.filterOpen;
            document.body.classList.toggle('filter-opened');
        },

        filterItems() {
            this.filteredItems = this.items;

            if (this.search) {
                // @ts-ignore
                this.filteredItems = this.search.filterItems(this.filteredItems);
            }

            if (this.filter && this.filter.data) {
                this.filteredItems = this.filteredItems.filter((item) => {
                    const navContact = document.querySelector('.main-nav-link#menu-contact-item') as HTMLAnchorElement;

                    // for each filter property
                    for (const property in this.filter!.data) {
                        let filterPropertyValue = this.filter!.data[property];

                        // if filter data property is empty, skip it
                        if ((!filterPropertyValue) || (Array.isArray(filterPropertyValue) && filterPropertyValue.length === 0)) {
                            if (property == 'federal_states') {
                                if (navContact) {
                                    let hrefAttr = navContact.getAttribute('href');
                                    if (hrefAttr) {
                                        const href = hrefAttr.split("?")[0];
                                        navContact.setAttribute('href', href);
                                    }
                                }
                            }

                            continue;
                        }

                        // Federal states
                        if (property == 'federal_states') {
                            let filteredValue = filterPropertyValue;
                            let itemValue = item.federal_states;
                            let isInRange = false;

                            // Contact main navigation
                            let href = "";
                            if (navContact) {
                                let hrefAttr = navContact.getAttribute('href');
                                if (hrefAttr) {
                                    href = hrefAttr.split("?")[0];
                                }

                                const federalStatesCount = filteredValue.length;
                                if (federalStatesCount == 1) {
                                    const element = document.querySelector('input.filter-input[name="project-list-filter-federal_states"][value="' + filteredValue + '"]') as HTMLInputElement;
                                    const locationId = element.dataset.location;
                                    const link = "?id_location=" + locationId + "#ce-contact-form";
                                    navContact.setAttribute('href', href + link);
                                } else {
                                    navContact.setAttribute('href', href);
                                }
                            }

                            const includesAny = (arr: any[], values: any[],) => values.some(v => arr.includes(v));
                            if (includesAny(itemValue, filteredValue)) {
                                isInRange = true;
                            }
                            if (!isInRange) return false;
                        }

                        // States
                        if (property == 'states') {
                            let filteredValue = filterPropertyValue;
                            let itemValue = item.states;
                            let isInRange = false;
                            if (itemValue.includes(filteredValue)) {
                                isInRange = true;
                            }
                            if (!isInRange) return false;
                        }
                    }

                    return true;
                });
            }

            if (this.pagination) {
                this.pagination.setTotalItems(this.filteredItems.length);
                this.pagination.goToPage(1);
            }

            // Change the number of items in the filter info
            const filterInfos = document.querySelectorAll(".project-list-pages") as NodeListOf<HTMLElement>;
            if (filterInfos) {
                // foreach filter info
                filterInfos.forEach((filterInfo) => {
                    let current = filterInfo.querySelector(".current") as HTMLElement;
                    if (current) {
                        current.innerHTML = this.filteredItems.length.toString();
                    }
                    let total = filterInfo.querySelector(".total") as HTMLElement;
                    if (total) {
                        total.innerHTML = this.items.length.toString();
                    }
                });
            }
        }
    }
}

export default List;
